// extracted by mini-css-extract-plugin
export default {"wrapper":"AddProductPlan_wrapper__JEtJR","tableTitle":"AddProductPlan_tableTitle__ljcgt"};